import { useEffect } from "react";

// Measures the real rendered height of a header element (works regardless of
// position: absolute/fixed) and publishes it as a global CSS custom property
// so every consumer (content-wrap, subnav, sticky in-page toolbars) reads the
// same live value instead of separately guessing a hardcoded pixel number.
export const useHeaderHeightVar = (ref) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const publish = () => {
      // A Smart Sticky Header (fixed, possibly compact or mid-transition)
      // never changes the offset of the content laid out under it.
      if (el.classList.contains("is-sticky")) return;
      document.documentElement.style.setProperty(
        "--elakay-header-height",
        `${el.getBoundingClientRect().height}px`
      );
    };

    publish();

    const observer = new ResizeObserver(publish);
    observer.observe(el);
    window.addEventListener("orientationchange", publish);

    return () => {
      observer.disconnect();
      window.removeEventListener("orientationchange", publish);
    };
  }, [ref]);
};
